// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".channel-members-view header h1{margin-bottom:12px}.channel-members-view header h1 a,.channel-members-view header h1 a:active{color:#fa0019;cursor:pointer}", ""]);
// Exports
module.exports = exports;
